const OPEN_STAGES = new Set([
  'identified',
  'assessing',
  'preparing',
  'under_review',
  'identified_legacy',
  'evaluating',
  'pursuing',
  'eligibility',
  'bid_decision',
  'ready_to_submit',
  'under_evaluation',
  'result_declared'
]);

const LOCKED_STAGES = new Set(['submitted', 'awarded', 'lost', 'withdrawn', 'cancelled']);
const LOCKED_STATUSES = new Set(['closed', 'awarded', 'cancelled']);

export const tenderStageKey = (tender) =>
  String(tender?.workflowStage || tender?.pipelineStage || tender?.stageLabel || '').toLowerCase();

/** Open pursuits can be edited. Submitted, awarded, lost, closed, and cancelled records are view only. */
export const canEditTender = (tender) => {
  const stage = tenderStageKey(tender);
  const status = String(tender?.status || '').toLowerCase();
  if (LOCKED_STATUSES.has(status) || LOCKED_STAGES.has(stage)) return false;
  if (!stage) return true;
  return OPEN_STAGES.has(stage);
};
